import { DateType } from "../../data/types/index";
import { StatementItemModel } from "./statementItemModel";
import { RequestsStates } from "../../data/enums/requestsStates";
import { HistoryStatus } from "../../data/enums/HistoryStatus";
import { ContractsTypes } from "../../data/enums/contractsTypes";
import i18n from "@/i18n";

/** Общая модель операции для выписок и истории операций */
export class StatementModel {
  public minDate: string = "";

  public maxDate: string = "";

  public token: string = "";

  public title: string = "";

  public isChart: boolean = true;

  public isSearch: boolean = false;

  public isPeriod: boolean = false;

  public operationsList: Array<StatementItemModel> = [];

  public months: Array<any> = [];

  public status: HistoryStatus = 31;

  public filterContractId: string | null = null;

  public RestIn: number = 0;

  public RestOut: number = 0;

  public contractType: ContractsTypes = ContractsTypes.None;

  public statusBar: Array<RequestsStates> = [];

  constructor(src: any) {
    this.minDate = src.minDate ?? "";
    this.maxDate = src.maxDate ?? "";
    this.token = src.token ?? "";
    this.title = src.title ?? "";
    this.isChart = src.isChart === false ? false : true;
    this.isPeriod = src.isPeriod === true ? true : false;
    this.isSearch = src.isSearch === true ? true : false;
    this.contractType = (src.contractType as ContractsTypes) ?? ContractsTypes.None;
    if (src.statusBar) {
      src.statusBar.map((state: number) => {
        this.statusBar.push(state as RequestsStates);
      })
    }
  }
}
